const $ = require('jquery');
const forEach = require('lodash.foreach');

const $buttons = $('input.button, input.webform-button--submit').not('input.js-hide');

forEach($buttons, item => {
  // find the nearest form element (the one that this button is contained in)
  const formIdToSubmit = $(item).closest('form').attr('id');

  // get the button's initial value set via Webforms, Drupal, etc.
  const btnValueText = $(item).val();

  // now replace the original buttons with a custom "button" link
  $(item).replaceWith('<span onclick="javascript:$(\'#' + formIdToSubmit + '\').submit();" class="button faux-submit">' + btnValueText + '</span>');

});

